import script from "./ShopView.vue?vue&type=script&setup=true&lang=js"
export * from "./ShopView.vue?vue&type=script&setup=true&lang=js"

import "./ShopView.vue?vue&type=style&index=0&id=29a1c12b&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-29a1c12b"]])

export default __exports__